import axios from 'axios'

function upload(url, formData) {
  return axios.post(url, formData).then(x => x.data)
}

export {upload}
